var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPriceChange = function SvgPriceChange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#E9F1FF",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#92B7FF",
    d: "M4 15V5h12v10zm3.6-1.875h1.2V12.5h.6q.255 0 .428-.18a.62.62 0 0 0 .172-.445V10a.62.62 0 0 0-.172-.445.57.57 0 0 0-.428-.18H7.6V8.75H10V7.5H8.8v-.625H7.6V7.5H7q-.254 0-.428.18a.62.62 0 0 0-.172.445V10q0 .265.172.445.173.18.428.18h1.8v.625H6.4v1.25h1.2zm4.8-.469 1.2-1.25h-2.4zM11.2 8.75h2.4L12.4 7.5z"
  })));
};
export default SvgPriceChange;